// This file was auto-generated by Fern from our API Definition.
export const ChannelGrantEffect = {
    Allow: "allow",
    Deny: "deny",
};
